// reducer.js
interface Package {
    id: number;
    created_at: string;
    updated_at: string;
    created_by_id: null;
    updated_by_id: null;
    name: string;
    code: null;
    type: string;
};

export interface PackagesState {
  data: Package[];
  error: string | null; 
}

export interface Action {
  type: string;
  payload: any;
}

const initialState: PackagesState = {
    data: [],
    error: null,
};

export const packagesReducer = (
    state: PackagesState = initialState,
    action: Action
): PackagesState => {   
    switch (action.type) {
        case "FETCH_PACKAGES_SUCCESS":
            return { ...state, data: action.payload };
        case "FETCH_PACKAGES_ERROR":
            return { ...state, error: action.payload };
        default:
            return state;
    }
};
